var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/components/contact-us-widget/contact-us.tsx
import React18 from "react";
import { ChatContainer, ChatContainerContent, ChatContainerHeader } from "@egds/react-virtual-agent-control";
import { gql as gql18, useQuery as useQuery2 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { VirtualAgentControl } from "@shared-ui/customer-virtual-agent-control";

// ../internal/src/components/egds-loader/egds-loader.tsx
import React from "react";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSLoader } from "@egds/react-core/loader";
var CenteredLoader = props => {
  const {
    blockSize = "full_size",
    loaderProps
  } = props;
  return /* @__PURE__ */React.createElement(EGDSLayoutGrid, {
    blockSize
  }, /* @__PURE__ */React.createElement(EGDSLayoutPosition, {
    type: "relative"
  }, /* @__PURE__ */React.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      top: "center",
      left: "center"
    },
    cloneElement: true
  }, /* @__PURE__ */React.createElement(EGDSLoader, __spreadValues({}, loaderProps))))));
};

// src/components/contact-us-widget/contact-us.tsx
import { ContactUsStateEvent as ContactUsStateEvent4, REQUIRED_EVENT, useContactUsState as useContactUsState4 } from "@shared-ui/retail-help-center-util";

// src/components/contact-us-widget/components/floating-action-button.tsx
import React5 from "react";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-button/egds-button.tsx
import React4 from "react";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React2 from "react";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { gql } from "@shared-ui/apollo-client-wrapper";
var __EGDSIconFragment = gql`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    title
    theme
    spotLight
  }
`;
var mapSpotlight = spotlight => {
  if (!spotlight) {
    return void 0;
  }
  switch (spotlight) {
    case "STANDARD" /* STANDARD */:
      return "standard";
    case "POSITIVE" /* POSITIVE */:
      return "positive";
    case "WARNING" /* WARNING */:
      return "warning";
    case "INFO" /* INFO */:
      return "info";
    default:
      return void 0;
  }
};
var HelpCenterEGDSIcon = ({
  data,
  size
}) => {
  var _a, _b;
  const iconName = data ? data.id : "";
  const finalSize = size != null ? size : (data == null ? void 0 : data.size) && EGDSIconSize[data.size];
  const spotlight = data == null ? void 0 : data.spotLight;
  const title = (_a = data == null ? void 0 : data.title) != null ? _a : void 0;
  return /* @__PURE__ */React2.createElement(EGDSIcon, {
    id: iconName,
    name: iconName,
    size: finalSize,
    title,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    spotlight: mapSpotlight(spotlight)
  });
};
HelpCenterEGDSIcon.displayName = "HelpCenterEGDSIcon";
HelpCenterEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React3 from "react";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";
var __EGDSGraphicFragment = gql2`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }
  }

  ${HelpCenterEGDSIcon.fragment}
`;
var EGDSGraphic = ({
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-button/egds-button.tsx
var __fragment = gql3`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    disabled
    icon {
      ...EGDSIconFragment
    }
    accessibility
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var HelpCenterEGDSButton = _a => {
  var _b = _a,
    {
      data,
      onClickHandler,
      isDisabled,
      type,
      iconPosition = "LEADING" /* LEADING */
    } = _b,
    otherProps = __objRest(_b, ["data", "onClickHandler", "isDisabled", "type", "iconPosition"]);
  const {
    primary,
    disabled,
    accessibility,
    __typename,
    icon
  } = data;
  const buttonProps = {
    disabled: disabled || isDisabled,
    title: accessibility,
    type,
    onClick: onClickHandler
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React4.createElement(EGDSPrimaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UISecondaryButton":
      return /* @__PURE__ */React4.createElement(EGDSSecondaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UITertiaryButton":
      return /* @__PURE__ */React4.createElement(EGDSTertiaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    default:
      return null;
  }
};
HelpCenterEGDSButton.displayName = "HelpCenterEGDSButton";
HelpCenterEGDSButton.fragment = __fragment;

// src/components/contact-us-widget/components/floating-action-button.tsx
var fragment = gql4`
  fragment FloatingActionButtonFragment on UISecondaryFloatingActionButton {
    disabled
    primary
    icon {
      ...EGDSIconFragment
    }
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var FloatingActionButton = ({
  onClick,
  unreadMessageCount,
  data
}) => {
  const {
    disabled,
    icon,
    primary
  } = data;
  return /* @__PURE__ */React5.createElement(EGDSLayoutPosition2, {
    type: "fixed",
    position: {
      bottom: "four",
      right: "four",
      zindex: "layer1"
    }
  }, /* @__PURE__ */React5.createElement(HelpCenterEGDSButton, {
    data: {
      primary,
      disabled,
      accessibility: primary,
      __typename: "UISecondaryButton",
      icon
    },
    isFullWidth: true,
    "data-stid": "fabButton",
    onClickHandler: onClick
  }));
};
FloatingActionButton.fragment = fragment;
FloatingActionButton.displayName = "ContactUsFloatingActionButton";

// src/components/contact-us-widget/components/tool-bar.tsx
import React6 from "react";
import { EGDSAvatar } from "@egds/react-core/avatar";
import { EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
import { EGDSToolbar, EGDSToolbarButton } from "@egds/react-core/toolbar";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
import { ContactUsStateEvent, ContactUsViewType, useContactUsState } from "@shared-ui/retail-help-center-util";
var fragment2 = gql5`
  fragment ContactUsToolBarFragmentV2 on ContactUsToolBarV2 {
    title
    closeIcon {
      ...EGDSIconFragment
    }
    vaIcon {
      ...EGDSIconFragment
    }
    vaImage
    vaTitle
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var ContactUsToolBarV2 = ({
  data
}) => {
  const {
    title,
    closeIcon,
    vaIcon,
    vaImage,
    vaTitle
  } = data;
  const [contactUsState, contactUsStateDispatch] = useContactUsState();
  const isVirtualAgent = contactUsState.view === ContactUsViewType.VIRTUAL_AGENT;
  const handleClose = () => {
    contactUsStateDispatch({
      type: ContactUsStateEvent.CLOSE_WIDGET
    });
  };
  if (isVirtualAgent) {
    return /* @__PURE__ */React6.createElement(EGDSSpacing, {
      padding: {
        blockstart: "three",
        blockend: "two"
      }
    }, /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement(EGDSLayoutPosition3, {
      type: "absolute",
      position: {
        left: "one"
      }
    }, /* @__PURE__ */React6.createElement(EGDSTertiaryButton2, {
      "data-stid": "contact-us-toolbar-close-button",
      onClick: handleClose
    }, /* @__PURE__ */React6.createElement(EGDSIcon2, {
      name: closeIcon.id,
      id: closeIcon.id
    }))), /* @__PURE__ */React6.createElement(EGDSLayoutFlex, {
      tag: "header",
      direction: "column",
      alignItems: "center",
      space: "one"
    }, /* @__PURE__ */React6.createElement("div", {
      "aria-hidden": "true"
    }, /* @__PURE__ */React6.createElement(EGDSAvatar, {
      image: {
        alt: "Virtual agent image",
        src: vaImage
      }
    })), /* @__PURE__ */React6.createElement(EGDSHeading, {
      tag: "h2",
      size: 7,
      overflow: "truncate"
    }, vaTitle))));
  }
  return /* @__PURE__ */React6.createElement(EGDSToolbar, {
    navigationContent: {
      navIconLabel: closeIcon.id,
      navButtonId: closeIcon.id,
      onClick: () => contactUsStateDispatch({
        type: ContactUsStateEvent.CLOSE_WIDGET
      })
    },
    toolbarTitle: title,
    toolbarActionContent: /* @__PURE__ */React6.createElement(EGDSToolbarButton, {
      buttonId: vaIcon.id,
      onClick: () => contactUsStateDispatch({
        type: ContactUsStateEvent.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType.VIRTUAL_AGENT
        }
      })
    }, /* @__PURE__ */React6.createElement(HelpCenterEGDSIcon, {
      data: vaIcon
    })),
    toolbarTitleA11yText: title
  });
};
ContactUsToolBarV2.fragment = fragment2;
ContactUsToolBarV2.displayName = "ContactUsToolBarV2";

// src/__generated__/types.ts
var ContactUsViewType2 = /* @__PURE__ */(ContactUsViewType5 => {
  ContactUsViewType5["BLANK_PAGE"] = "BLANK_PAGE";
  ContactUsViewType5["CHAT_OPTIONS"] = "CHAT_OPTIONS";
  ContactUsViewType5["CONTACT_OPTIONS"] = "CONTACT_OPTIONS";
  ContactUsViewType5["LANDING_PAGE"] = "LANDING_PAGE";
  ContactUsViewType5["VIRTUAL_AGENT"] = "VIRTUAL_AGENT";
  ContactUsViewType5["VOICE_OPTIONS"] = "VOICE_OPTIONS";
  return ContactUsViewType5;
})(ContactUsViewType2 || {});

// src/components/contact-us-view/contact-us-view.tsx
import React17, { useState } from "react";
import { gql as gql17, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";

// src/components/contact-us-view/components/contact-us-heading.tsx
import React7 from "react";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
var fragment3 = gql6`
  fragment ContactUsHeadingFragment on ContactUsHeading {
    __typename
    text
  }
`;
var EGDSHeadingStyleMap = {
  ["H1" /* H1 */]: "h1",
  ["H2" /* H2 */]: "h2",
  ["H3" /* H3 */]: "h3",
  ["H4" /* H4 */]: "h4",
  ["H5" /* H5 */]: "h5",
  ["H6" /* H6 */]: "h6",
  ["H7" /* H7 */]: "h6",
  ["H8" /* H8 */]: "h6"
};
var EGDSHeadingSizeMap = {
  ["H1" /* H1 */]: 3,
  ["H2" /* H2 */]: 4,
  ["H3" /* H3 */]: 5,
  ["H4" /* H4 */]: 6,
  ["H5" /* H5 */]: 7,
  ["H6" /* H6 */]: 8,
  ["H7" /* H7 */]: 8,
  ["H8" /* H8 */]: 8
};
var ContactUsHeading = ({
  data,
  headingSize,
  spacingNeeded,
  margin,
  padding
}) => {
  const tag = headingSize !== null ? EGDSHeadingStyleMap[headingSize] : void 0;
  const size = headingSize ? EGDSHeadingSizeMap[headingSize] : void 0;
  const marginSize = margin != null ? margin : {
    blockstart: "two"
  };
  const paddingSize = padding != null ? padding : void 0;
  return /* @__PURE__ */React7.createElement(EGDSSpacing2, {
    margin: {
      blockstart: spacingNeeded ? "six" : "unset"
    }
  }, /* @__PURE__ */React7.createElement("div", {
    "data-stid": "help-center-contact-us-heading"
  }, /* @__PURE__ */React7.createElement(EGDSSpacing2, {
    margin: marginSize,
    padding: paddingSize
  }, /* @__PURE__ */React7.createElement(EGDSHeading2, {
    tag,
    size
  }, data.text))));
};
ContactUsHeading.fragment = fragment3;
ContactUsHeading.displayName = "ContactUsHeading";

// src/components/contact-us-view/components/contact-us-paragraph.tsx
import React8 from "react";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSParagraph } from "@egds/react-core/text";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
var fragment4 = gql7`
  fragment ContactUsParagraphFragment on ContactUsParagraph {
    __typename
    text
  }
`;
var EGDSParagraphSizeMap = {
  ["P1" /* P1 */]: 1,
  ["P2" /* P2 */]: 2,
  ["P3" /* P3 */]: 3
};
var ContactUsParagraph = ({
  data,
  paragraphSize,
  spacingNeeded
}) => {
  return /* @__PURE__ */React8.createElement(EGDSSpacing3, {
    margin: {
      blockstart: spacingNeeded ? "two" : "unset"
    }
  }, /* @__PURE__ */React8.createElement("div", {
    "data-stid": "help-center-contact-us-paragraph"
  }, /* @__PURE__ */React8.createElement(EGDSParagraph, {
    size: EGDSParagraphSizeMap[paragraphSize]
  }, data.text)));
};
ContactUsParagraph.fragment = fragment4;
ContactUsParagraph.displayName = "ContactUsParagraph";

// src/components/contact-us-view/components/contact-us-card.tsx
import React9 from "react";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { gql as gql9 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { ContactUsStateEvent as ContactUsStateEvent2, ContactUsViewType as ContactUsViewType3, useContactUsState as useContactUsState2, useVirtualAgentContext } from "@shared-ui/retail-help-center-util";

// src/components/contact-us-view/analytics/helper.ts
var buildWorkFlowList = (contactUsClickStreamAnalytics, intentSelected, productSelected) => {
  if (contactUsClickStreamAnalytics.workFlowList && contactUsClickStreamAnalytics.workFlowList.length > 0) {
    const firstWorkFlow = contactUsClickStreamAnalytics.workFlowList[0];
    const intent = (intentSelected == null ? void 0 : intentSelected.split("/")) || [];
    const product = (productSelected == null ? void 0 : productSelected.split("/")) || [];
    const workflow = {
      intent: (intent == null ? void 0 : intent.length) > 0 ? intent[1] : "",
      automation_status: firstWorkFlow.automationStatus,
      automation_status_reason: firstWorkFlow.automationStatusReason,
      product_line: (product == null ? void 0 : product.length) > 0 ? product[1] : "",
      channel: firstWorkFlow.channel
    };
    return {
      work_flow_list: {
        work_flow_list: [workflow]
      }
    };
  }
  return {};
};
var buildClickStreamForContactUs = (contactUsClickStreamAnalytics, intentSelected, productSelected) => {
  var _a, _b;
  const contactUsWorkFlow = buildWorkFlowList(contactUsClickStreamAnalytics, intentSelected, productSelected);
  return __spreadValues({
    event: {
      event_name: contactUsClickStreamAnalytics.event.eventName,
      event_version: (_a = contactUsClickStreamAnalytics.event.eventVersion) != null ? _a : "1.0.0",
      event_type: contactUsClickStreamAnalytics.event.eventType,
      event_category: "help_center",
      action_location: "home_page"
    },
    experience: {
      page_name: contactUsClickStreamAnalytics.experience.pageName,
      app_name: contactUsClickStreamAnalytics.experience.appName,
      app_version: contactUsClickStreamAnalytics.experience.appVersion,
      page_name_detailed: (_b = contactUsClickStreamAnalytics.experience.pageNameDetailed) != null ? _b : ""
    }
  }, contactUsWorkFlow);
};

// src/components/contact-us-view/components/contact-us-click-stream.tsx
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";
var ContactUsClickStreamFragment = gql8`
  fragment ContactUsClickStreamFragment on ContactUsClickStreamAnalytics {
    event {
      eventName
      eventType
      eventVersion
      __typename
    }
    __typename
    experience {
      pageName
      appName
      appVersion
      pageNameDetailed
      __typename
    }
    workFlowList {
      intent
      orderLineId
      productLine
      subIntent
      automationStatus
      automationStatusReason
      channel
      __typename
    }
  }
`;

// src/components/contact-us-view/components/contact-us-card.tsx
var fragment5 = gql9`
  fragment ContactUsCardFragment on ContactUsCard {
    __typename
    icon {
      ...EGDSIconFragment
    }
    heading {
      ...ContactUsHeadingFragment
    }
    subheading {
      ...ContactUsParagraphFragment
    }
    intentPayload {
      payload
      skillName
      vaText
    }
    cardClickStreamAnalytics {
      ...ContactUsClickStreamFragment
    }
  }
  ${ContactUsClickStreamFragment}
  ${HelpCenterEGDSIcon.fragment}
  ${ContactUsHeading.fragment}
  ${ContactUsParagraph.fragment}
`;
var ContactUsCard = ({
  data,
  queryPayload
}) => {
  const {
    controller
  } = useVirtualAgentContext();
  const trackClick = useEgClickstream();
  const [contactUsState, contactUsStateDispatch] = useContactUsState2();
  const invokeVaWithIntent = intentPayload => {
    var _a;
    const message = {
      text: intentPayload.vaText,
      messageType: "POSTBACK",
      intent: intentPayload.skillName
    };
    if (intentPayload == null ? void 0 : intentPayload.payload) {
      const payload = JSON.parse(intentPayload.payload);
      const product = ((_a = queryPayload == null ? void 0 : queryPayload.productSelected) == null ? void 0 : _a.split("/")) || [];
      payload.product = (product == null ? void 0 : product.length) > 0 ? product[1] : "";
      message.payload = JSON.stringify(payload);
      controller.sendMessage(message);
    }
    contactUsStateDispatch({
      type: ContactUsStateEvent2.CHANGE_VIEW,
      payload: {
        view: ContactUsViewType3.VIRTUAL_AGENT
      }
    });
  };
  const handleClick = () => {
    var _a, _b, _c;
    if (data == null ? void 0 : data.cardClickStreamAnalytics) {
      trackClick(buildClickStreamForContactUs(data == null ? void 0 : data.cardClickStreamAnalytics, (_a = queryPayload == null ? void 0 : queryPayload.intentSelected) != null ? _a : "", (_b = queryPayload == null ? void 0 : queryPayload.productSelected) != null ? _b : ""));
    }
    if (data == null ? void 0 : data.intentPayload) {
      invokeVaWithIntent(data == null ? void 0 : data.intentPayload);
    } else if (contactUsState.view === ContactUsViewType3.CONTACT_OPTIONS && ((_c = data.icon) == null ? void 0 : _c.id) === "chat") {
      contactUsStateDispatch({
        type: ContactUsStateEvent2.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType3.CHAT_OPTIONS
        }
      });
    } else if (contactUsState.view === ContactUsViewType3.CONTACT_OPTIONS) {
      contactUsStateDispatch({
        type: ContactUsStateEvent2.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType3.VOICE_OPTIONS
        }
      });
    }
  };
  return /* @__PURE__ */React9.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React9.createElement(EGDSCard, {
    padded: true,
    border: true,
    "data-stid": "help-center-contact-us-card",
    onClick: () => handleClick()
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    direction: "row",
    alignItems: "center"
  }, data.icon && /* @__PURE__ */React9.createElement(HelpCenterEGDSIcon, {
    data: {
      id: data.icon.id,
      description: data.icon.description,
      __typename: data.icon.__typename,
      theme: null,
      spotLight: null,
      size: null,
      title: null
    }
  }), /* @__PURE__ */React9.createElement(EGDSSpacing4, {
    padding: {
      inlinestart: "three"
    }
  }, /* @__PURE__ */React9.createElement(EGDSCardContentSection, {
    padded: false
  }, data.heading && /* @__PURE__ */React9.createElement(ContactUsHeading, {
    data: data.heading,
    headingSize: "H4" /* H4 */,
    spacingNeeded: false,
    margin: data.subheading ? {
      blockstart: "two"
    } : "unset"
  }), data.subheading && /* @__PURE__ */React9.createElement(ContactUsParagraph, {
    data: data.subheading,
    paragraphSize: "P3" /* P3 */,
    spacingNeeded: true
  }))))));
};
ContactUsCard.fragment = fragment5;
ContactUsCard.displayName = "ContactUsCard";

// src/components/contact-us-view/components/contact-us-button.tsx
import React10 from "react";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { ContactUsStateEvent as ContactUsStateEvent3, ContactUsViewType as ContactUsViewType4, useContactUsState as useContactUsState3 } from "@shared-ui/retail-help-center-util";
var fragment6 = gql10`
  fragment ContactUsButtonFragment on ContactUsButton {
    __typename
    button {
      ...EGDSButtonFragment
    }
    buttonClickStreamAnalytics {
      ...ContactUsClickStreamFragment
    }
  }
  ${HelpCenterEGDSButton.fragment}
  ${ContactUsClickStreamFragment}
`;
var ContactUsButton = ({
  data,
  payload,
  setQueryPayload,
  setPayload,
  onClickOverride,
  isSignInButton,
  isErrorView
}) => {
  const [contactUsState, contactUsStateDispatch] = useContactUsState3();
  const trackClick = useEgClickstream2();
  let justify = "flex-end";
  if (isErrorView) {
    justify = "center";
  } else if (isSignInButton) {
    justify = "flex-start";
  }
  const size = isSignInButton ? EGDSButtonSize.SMALL : EGDSButtonSize.LARGE;
  const widthStyle = isErrorView ? void 0 : {
    width: isSignInButton ? "70px" : "160px"
  };
  const disableButton = payload ? !payload.intentSelected || !payload.productSelected : false;
  const isNonEmptyString = value => typeof value === "string" && value.trim() !== "";
  const handleClick = () => {
    if ((data == null ? void 0 : data.buttonClickStreamAnalytics) && isNonEmptyString(payload == null ? void 0 : payload.intentSelected) && isNonEmptyString(payload == null ? void 0 : payload.productSelected)) {
      trackClick(buildClickStreamForContactUs(data == null ? void 0 : data.buttonClickStreamAnalytics, payload == null ? void 0 : payload.intentSelected, payload == null ? void 0 : payload.productSelected));
    }
    if (isErrorView) {
      contactUsStateDispatch({
        type: ContactUsStateEvent3.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType4.LANDING_PAGE
        }
      });
      return;
    }
    if (onClickOverride) {
      contactUsStateDispatch({
        type: ContactUsStateEvent3.REDIRECT_RETURN,
        payload: {
          view: ContactUsViewType4.LANDING_PAGE
        }
      });
      onClickOverride();
      return;
    }
    if (contactUsState.view === ContactUsViewType4.LANDING_PAGE) {
      if (setQueryPayload && payload) {
        setQueryPayload(payload);
      }
      contactUsStateDispatch({
        type: ContactUsStateEvent3.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType4.CONTACT_OPTIONS
        }
      });
    } else if (contactUsState.view === ContactUsViewType4.CONTACT_OPTIONS) {
      if (setPayload && payload && setQueryPayload) {
        setPayload({
          intentSelected: "",
          productSelected: "",
          viewType: contactUsState.view
        });
        setQueryPayload({
          intentSelected: "",
          productSelected: "",
          viewType: contactUsState.view
        });
      }
      contactUsStateDispatch({
        type: ContactUsStateEvent3.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType4.LANDING_PAGE
        }
      });
    } else if (contactUsState.view === ContactUsViewType4.VOICE_OPTIONS) {
      contactUsStateDispatch({
        type: ContactUsStateEvent3.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType4.CONTACT_OPTIONS
        }
      });
    } else if (contactUsState.view === ContactUsViewType4.CHAT_OPTIONS) {
      contactUsStateDispatch({
        type: ContactUsStateEvent3.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType4.CONTACT_OPTIONS
        }
      });
    }
  };
  return /* @__PURE__ */React10.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React10.createElement("div", {
    "data-stid": "help-center-contact-us-button",
    style: {
      display: "flex",
      justifyContent: justify
    }
  }, /* @__PURE__ */React10.createElement(HelpCenterEGDSButton, {
    data: __spreadProps(__spreadValues({}, data.button), {
      icon: null
    }),
    size,
    style: widthStyle,
    isFullWidth: isErrorView,
    onClickHandler: handleClick,
    isDisabled: disableButton
  })));
};
ContactUsButton.fragment = fragment6;
ContactUsButton.displayName = "ContactUsButton";

// src/components/contact-us-view/components/contact-us-phone-number.tsx
import React11 from "react";
import { EGDSCard as EGDSCard2, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";
var fragment7 = gql11`
  fragment ContactUsPhoneNumberFragment on ContactUsPhoneNumber {
    __typename
    label {
      text
    }
    phoneNumber {
      text
    }
  }
`;
var ContactUsPhoneNumber = ({
  data
}) => {
  return /* @__PURE__ */React11.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React11.createElement(EGDSCard2, {
    padded: true,
    "data-stid": "help-center-contact-phone-number",
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React11.createElement(EGDSCardContentSection2, {
    padded: false
  }, /* @__PURE__ */React11.createElement(EGDSSpacing6, {
    margin: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React11.createElement(EGDSText, {
    align: "left",
    hyphens: "none",
    overflow: "wrap",
    spacing: "one",
    theme: "standard",
    whiteSpace: "normal",
    inline: true,
    typeStyle: {
      customStyle: "text-large",
      customTheme: "standard"
    }
  }, data.phoneNumber.text)), /* @__PURE__ */React11.createElement(EGDSSpacing6, null, /* @__PURE__ */React11.createElement(EGDSText, {
    align: "left",
    hyphens: "none",
    overflow: "wrap",
    spacing: "one",
    theme: "secondary",
    whiteSpace: "normal",
    inline: true,
    typeStyle: {
      customStyle: "text-small",
      customTheme: "standard"
    }
  }, data.label.text)))));
};
ContactUsPhoneNumber.fragment = fragment7;
ContactUsPhoneNumber.displayName = "ContactUsPhoneNumber";

// src/components/contact-us-view/components/contact-us-error-view.tsx
import React12 from "react";
import { EGDSIcon as EGDSIcon3, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";
var fragment8 = gql12`
  fragment ContactUsErrorViewFragment on ContactUsErrorViewV2 {
    __typename
    errorIcon {
      ...EGDSIconFragment
    }
    errorRetryButton {
      ...ContactUsButtonFragment
    }
    title {
      text
    }
    message {
      text
    }
  }
  ${HelpCenterEGDSIcon.fragment}
  ${ContactUsButton.fragment}
`;
var ContactUsErrorView = ({
  data
}) => {
  var _a;
  return /* @__PURE__ */React12.createElement(React12.Fragment, null, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    margin: {
      blockstart: "sixteen"
    }
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlex3, {
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    direction: "column",
    space: "two"
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem, null, (data == null ? void 0 : data.errorIcon) && /* @__PURE__ */React12.createElement(EGDSIcon3, {
    id: data.errorIcon.id,
    name: data.errorIcon.id,
    size: EGDSIconSize2.XLARGE,
    title: (_a = data == null ? void 0 : data.errorIcon.title) != null ? _a : void 0,
    spotlight: "warning"
  })), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React12.createElement(EGDSHeading3, {
    align: "center"
  }, data.title.text)), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React12.createElement(EGDSText2, {
    align: "center",
    theme: "standard",
    whiteSpace: "normal"
  }, data.message.text)))), (data == null ? void 0 : data.errorRetryButton) && /* @__PURE__ */React12.createElement(ContactUsButton, {
    data: data.errorRetryButton,
    isErrorView: true
  }));
};
ContactUsErrorView.fragment = fragment8;
ContactUsErrorView.displayName = "ContactUsErrorView";

// src/components/contact-us-view/components/contact-us-menu.tsx
import React15 from "react";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { gql as gql15 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-select/egds-select.tsx
import React14 from "react";
import { EGDSSelect } from "@egds/react-core/input";
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-select/egds-basic-option.tsx
import React13 from "react";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";
var __Fragment = gql13`
  fragment EGDSBasicOptionFragment on EGDSBasicOption {
    value
    selected
    label
  }
`;
var EGDSBasicOption = ({
  data
}) => {
  var _a;
  return /* @__PURE__ */React13.createElement("option", {
    key: data.value,
    value: data.value,
    "aria-selected": (_a = data.selected) != null ? _a : false
  }, data.label);
};
EGDSBasicOption.displayName = "EGDSBasicOption";
EGDSBasicOption.fragment = __Fragment;

// ../internal/src/components/egds-select/egds-select.tsx
var __Fragment2 = gql14`
  fragment EGDSSelectFragment on EGDSBasicSelect {
    options {
      ...EGDSBasicOptionFragment
    }
    label
    egdsElementId
    readOnly
  }
  ${EGDSBasicOption.fragment}
`;
var HelpCenterEGDSSelect = ({
  emptyState,
  value,
  onChange,
  data,
  required
}) => {
  const {
    label,
    egdsElementId,
    options,
    readOnly
  } = data;
  if (!egdsElementId || options.length === 0) {
    return null;
  }
  return /* @__PURE__ */React14.createElement(EGDSSelect, {
    readOnly,
    value,
    label,
    id: egdsElementId,
    onChange,
    emptyState,
    required
  }, options.map((optionItem, index) => optionItem.__typename === "EGDSBasicOption" && /* @__PURE__ */React14.createElement(EGDSBasicOption, {
    key: `option-${index}`,
    data: optionItem
  })));
};
HelpCenterEGDSSelect.displayName = "HelpCenterEGDSSelect";
HelpCenterEGDSSelect.fragment = __Fragment2;

// src/components/contact-us-view/components/contact-us-menu.tsx
var fragment9 = gql15`
  fragment ContactUsMenuFragment on ContactUsMenu {
    __typename
    menu {
      ...EGDSSelectFragment
    }
  }
  ${HelpCenterEGDSSelect.fragment}
`;
var ContactUsMenu = ({
  data,
  payload,
  setPayload
}) => {
  const {
    egdsElementId,
    label,
    options,
    readOnly
  } = data.menu;
  const onChange = e => {
    const {
      id,
      value
    } = e.target;
    setPayload(prev => __spreadProps(__spreadValues({}, prev), {
      intentSelected: id === "intentSelect" ? value : prev.intentSelected,
      productSelected: id === "productSelect" ? value : prev.productSelected
    }));
  };
  let currentValue = egdsElementId === "intentSelect" ? payload.intentSelected : payload.productSelected;
  if (currentValue === void 0 || currentValue === null) {
    currentValue = "";
  }
  return /* @__PURE__ */React15.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React15.createElement("div", {
    "data-stid": "help-center-contact-us-menu"
  }, /* @__PURE__ */React15.createElement(HelpCenterEGDSSelect, {
    data: data.menu,
    value: currentValue,
    emptyState: true,
    onChange,
    required: true
  })));
};
ContactUsMenu.fragment = fragment9;
ContactUsMenu.displayName = "ContactUsMenu";

// src/components/contact-us-view/components/contact-us-sign-in-card.tsx
import React16 from "react";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { gql as gql16 } from "@shared-ui/apollo-client-wrapper";
var fragment10 = gql16`
  fragment ContactUsSignInCardFragment on ContactUsSignInCard {
    __typename
    signInSubheading: subheading {
      ...ContactUsParagraphFragment
    }
    signInButton {
      ...ContactUsButtonFragment
      button {
        __typename
        primary
        action {
          __typename
          ... on UILinkAction {
            resource {
              __typename
              value
            }
            accessibility
          }
        }
      }
    }
  }
  ${ContactUsParagraph.fragment}
  ${ContactUsButton.fragment}
`;
var ContactUsSignInCard = ({
  data
}) => {
  var _a;
  const {
    signInSubheading,
    signInButton
  } = data;
  const href = ((_a = signInButton.button.action) == null ? void 0 : _a.__typename) === "UILinkAction" ? signInButton.button.action.resource.value : void 0;
  const handleSignIn = () => {
    if (href) {
      window.location.href = href;
    }
  };
  return /* @__PURE__ */React16.createElement(EGDSSpacing9, {
    margin: {
      blockstart: "four",
      blockend: "six"
    }
  }, /* @__PURE__ */React16.createElement("div", {
    "data-stid": "help-center-contact-us-sign-in-card",
    style: {
      borderRadius: "8px",
      padding: "16px",
      background: "#EFF3F7"
    }
  }, /* @__PURE__ */React16.createElement(ContactUsParagraph, {
    data: signInSubheading,
    paragraphSize: "P2" /* P2 */,
    spacingNeeded: false
  }), /* @__PURE__ */React16.createElement(ContactUsButton, {
    data: data.signInButton,
    isSignInButton: true,
    onClickOverride: handleSignIn
  })));
};
ContactUsSignInCard.fragment = fragment10;
ContactUsSignInCard.displayName = "ContactUsSignInCard";

// src/components/contact-us-view/contact-us-view.tsx
var __Query = gql17`
  query ContactUsInfo($context: ContextInput!, $requestPayload: ContactUsPayloadInput!) {
    contactUsInfo(context: $context, requestPayload: $requestPayload) {
      contactUsByViewType {
        ...ContactUsHeadingFragment
        ...ContactUsParagraphFragment
        ...ContactUsCardFragment
        ...ContactUsButtonFragment
        ...ContactUsPhoneNumberFragment
        ...ContactUsClickStreamFragment
        ...ContactUsErrorViewFragment
        ...ContactUsMenuFragment
        ...ContactUsSignInCardFragment
      }
    }
  }
  ${ContactUsHeading.fragment}
  ${ContactUsParagraph.fragment}
  ${ContactUsCard.fragment}
  ${ContactUsButton.fragment}
  ${ContactUsPhoneNumber.fragment}
  ${ContactUsClickStreamFragment}
  ${ContactUsErrorView.fragment}
  ${ContactUsMenu.fragment}
  ${ContactUsSignInCard.fragment}
`;
var ContactUsViewContent = ({
  skipSsr = false,
  requestPayload = {
    intentSelected: "",
    productSelected: "",
    viewType: "LANDING_PAGE" /* LANDING_PAGE */
  }
}) => {
  var _a, _b;
  const {
    context
  } = useBexApi();
  const trackClick = useEgClickstream3();
  const {
    intentSelected,
    productSelected,
    viewType
  } = requestPayload;
  const [payload, setPayload] = useState(requestPayload);
  const [queryPayload, setQueryPayload] = useState(requestPayload);
  const fireClickstreamEvent = ele => {
    if (payload.intentSelected === "" && payload.productSelected === "") {
      trackClick(buildClickStreamForContactUs(ele, "", ""));
    }
  };
  const variables = {
    context,
    requestPayload: {
      intentSelected: queryPayload.intentSelected,
      productSelected: queryPayload.productSelected,
      viewType
    }
  };
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    context: {
      shouldLogPerformance: true
    },
    ssr: !skipSsr,
    variables,
    fetchPolicy: "network-only"
  });
  if (loading) {
    return /* @__PURE__ */React17.createElement(CenteredLoader, null);
  }
  if (error || !data) {
    return null;
  }
  return (_b = (_a = data == null ? void 0 : data.contactUsInfo) == null ? void 0 : _a.contactUsByViewType) == null ? void 0 : _b.map(ele => {
    switch (ele == null ? void 0 : ele.__typename) {
      case "ContactUsHeading":
        return /* @__PURE__ */React17.createElement(ContactUsHeading, {
          data: ele,
          key: "heading",
          headingSize: "H3" /* H3 */,
          spacingNeeded: true
        });
      case "ContactUsParagraph":
        return /* @__PURE__ */React17.createElement(ContactUsParagraph, {
          data: ele,
          key: "paragraph",
          paragraphSize: "P2" /* P2 */,
          spacingNeeded: true
        });
      case "ContactUsCard":
        return /* @__PURE__ */React17.createElement(ContactUsCard, {
          data: ele,
          key: "card",
          queryPayload
        });
      case "ContactUsMenu":
        return /* @__PURE__ */React17.createElement(ContactUsMenu, {
          data: ele,
          key: ele.menu.egdsElementId,
          payload,
          setPayload
        });
      case "ContactUsButton":
        return /* @__PURE__ */React17.createElement(ContactUsButton, {
          data: ele,
          key: "button",
          payload,
          setQueryPayload,
          setPayload
        });
      case "ContactUsPhoneNumber":
        return /* @__PURE__ */React17.createElement(ContactUsPhoneNumber, {
          data: ele,
          key: "phone-number"
        });
      case "ContactUsSignInCard":
        return /* @__PURE__ */React17.createElement(ContactUsSignInCard, {
          data: ele,
          key: "signInCard"
        });
      case "ContactUsClickStreamAnalytics":
        fireClickstreamEvent(ele);
        return null;
      case "ContactUsErrorViewV2":
        return /* @__PURE__ */React17.createElement(ContactUsErrorView, {
          data: ele,
          key: "error-view"
        });
      default:
        return null;
    }
  });
};
ContactUsViewContent.displayName = "sharedui-ContactUsView";

// src/components/contact-us-widget/contact-us.tsx
var __Query2 = gql18`
  query ContactUsInitializeContent($context: ContextInput!) {
    contactUsInfo(context: $context) {
      contactUsInitializeContent {
        ... on ContactUsInitialization {
          contactUsFloatingActionButton {
            floatingActionButton {
              ...FloatingActionButtonFragment
            }
          }
          contactUsToolBar {
            ...ContactUsToolBarFragmentV2
          }
        }
      }
    }
  }
  ${FloatingActionButton.fragment}
  ${ContactUsToolBarV2.fragment}
`;
var vacEvents = {
  vacConversationCreatedEvent: "VAC_ConversationCreated",
  vacConversationJoinedEvent: "VAC_ConversationJoined",
  vacInitializedEvent: "VAC_Initialized",
  vacLazyInitializedEvent: "VAC_LazyInitializeFailed",
  vacCreateFrameFailedEvent: "VAC_CreateFrameFailed",
  vacStartFrameFailedEvent: "VAC_StartFrameFailed",
  vacConversationCreateFailedEvent: "VAC_ConversationCreateFailed",
  vacConversationJoinFailedEvent: "VAC_ConversationJoinFailed",
  vacFabPresented: "VAC_FabPresented"
};
var ContactUs = ({
  skipSsr,
  vacProps,
  handleEvents,
  intentMessage,
  isComponentTest
}) => {
  var _a, _b, _c, _d, _e;
  const {
    context
  } = useBexApi2();
  const [contactUsState, contactUsStateDispatch] = useContactUsState4();
  const localStorageContactUsView = localStorage.getItem("contactUsView");
  const shouldOpenWidgetOnPageLoad = localStorage.getItem("shouldOpenWidget") === "true";
  const subscribedEvents = Object.values(vacEvents);
  const [shouldMountVirtualAgentControl, setShouldMountVirtualAgentControl] = React18.useState(false);
  const defaultPayload = {
    skipSsr,
    requestPayload: {
      viewType: contactUsState.view,
      intentSelected: "",
      productSelected: ""
    }
  };
  const variables = {
    context
  };
  React18.useEffect(() => {
    var _a2;
    const beforeUnload = () => {
      if (localStorage.getItem("contactUsView") === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */) {
        localStorage.setItem("shouldOpenWidget", "true");
      }
    };
    if (isComponentTest && !intentMessage) {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.OPEN_WIDGET,
        payload: {
          view: "LANDING_PAGE" /* LANDING_PAGE */
        }
      });
    } else if (intentMessage || localStorageContactUsView === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && shouldOpenWidgetOnPageLoad) {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.OPEN_WIDGET,
        payload: {
          view: "VIRTUAL_AGENT" /* VIRTUAL_AGENT */
        }
      });
    } else if (((_a2 = context.identity) == null ? void 0 : _a2.authState) === "ANONYMOUS") {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.CLOSE_WIDGET,
        payload: {
          view: "VIRTUAL_AGENT" /* VIRTUAL_AGENT */
        }
      });
    } else if (localStorage.getItem("shouldOpenWidget") !== null) {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.OPEN_WIDGET,
        payload: {
          view: localStorageContactUsView
        }
      });
    }
    window.addEventListener("beforeunload", beforeUnload);
    return () => {
      window.addEventListener("beforeunload", beforeUnload);
      localStorage.removeItem("shouldOpenWidget");
      localStorage.removeItem("contactUsView");
    };
  }, []);
  const handleFabClick = () => {
    if (localStorageContactUsView === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */) {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.OPEN_WIDGET,
        payload: {
          view: "VIRTUAL_AGENT" /* VIRTUAL_AGENT */
        }
      });
    } else {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.OPEN_WIDGET,
        payload: {
          view: contactUsState.view
        }
      });
    }
  };
  const virtualAgentControl = /* @__PURE__ */React18.createElement(VirtualAgentControl, {
    applicationName: "ecp-help-center",
    pageName: "ecp-help-center",
    clientOverrides: {
      subscribedEvents: [...subscribedEvents, ...REQUIRED_EVENT],
      eventHandler: event => {
        handleEvents(event);
      },
      enableAutoOpenChatWidget: false,
      embedded: vacProps.embedded,
      containerElement: document.getElementById("vac-container"),
      configurationOverrides: {
        hideHeader: vacProps.hideHeader,
        hideAvatar: vacProps.hideAvatar,
        textInputPlaceHolder: vacProps.textInputPlaceHolder
      },
      intentMessage
    },
    inputs: {},
    skipSsr: true
  });
  const timeoutToMountVac = () => {
    setTimeout(() => {
      setShouldMountVirtualAgentControl(true);
    }, 100);
  };
  const {
    data,
    error,
    loading
  } = useQuery2(__Query2, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr: !skipSsr
  });
  const fab = (_a = data == null ? void 0 : data.contactUsInfo.contactUsInitializeContent) == null ? void 0 : _a.contactUsFloatingActionButton.floatingActionButton;
  const contactUsToolBar = (_b = data == null ? void 0 : data.contactUsInfo.contactUsInitializeContent) == null ? void 0 : _b.contactUsToolBar;
  if (loading || error || !data) {
    return null;
  }
  return /* @__PURE__ */React18.createElement(React18.Fragment, null, !contactUsState.shouldWidgetBeVisible && localStorageContactUsView === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && /* @__PURE__ */React18.createElement(FloatingActionButton, {
    onClick: () => handleFabClick(),
    data: fab
  }), /* @__PURE__ */React18.createElement(ChatContainer, {
    visible: contactUsState.shouldWidgetBeVisible,
    padded: true
  }, /* @__PURE__ */React18.createElement(ChatContainerHeader, null, /* @__PURE__ */React18.createElement(ContactUsToolBarV2, {
    data: contactUsToolBar
  })), /* @__PURE__ */React18.createElement(ChatContainerContent, null, contactUsState.view !== "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && /* @__PURE__ */React18.createElement(ContactUsViewContent, {
    inputs: {},
    requestPayload: {
      viewType: ((_c = defaultPayload.requestPayload) == null ? void 0 : _c.viewType) || "LANDING_PAGE" /* LANDING_PAGE */,
      intentSelected: (_d = defaultPayload.requestPayload) == null ? void 0 : _d.intentSelected,
      productSelected: (_e = defaultPayload.requestPayload) == null ? void 0 : _e.productSelected
    }
  }), /* @__PURE__ */React18.createElement("div", {
    role: "region",
    "aria-label": "Virtual agent",
    id: "vac-container",
    className: "hide-vac-false",
    "data-stid": "vacContainer",
    style: {
      height: contactUsState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ ? "100%" : "0%",
      visibility: contactUsState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ ? "visible" : "hidden",
      minHeight: contactUsState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ ? "33.8rem" : "0rem"
    }
  }, contactUsState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && contactUsState.shouldWidgetBeVisible && vacProps.vacState.isLoading && /* @__PURE__ */React18.createElement(CenteredLoader, null), contactUsState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && contactUsState.shouldWidgetBeVisible && !shouldMountVirtualAgentControl && timeoutToMountVac(), contactUsState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && contactUsState.shouldWidgetBeVisible && shouldMountVirtualAgentControl && virtualAgentControl))));
};
ContactUs.displayName = "sharedui-ContactUs";
export { ContactUs, ContactUsViewType2 as ContactUsViewType };
//# sourceMappingURL=index.js.map